import * as React from "react";
const SvgFiRrPenFancy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-fancy_svg__a)">
      <path
        fill="#062147"
        d="M24 3c0-.801-.314-1.555-.88-2.122a3.004 3.004 0 0 0-4.242 0L8.747 11.01c-.05.008-4.102 1.277-4.102 1.277A4.31 4.31 0 0 0 1.753 15.4L.026 22.77a.998.998 0 0 0 1.203 1.202l7.37-1.727a4.31 4.31 0 0 0 3.111-2.89s1.27-4.053 1.277-4.102L23.122 5.122C23.687 4.555 24 3.802 24 3M9.803 18.756a2.3 2.3 0 0 1-1.661 1.542l-3.953.927 2.519-2.518a.999.999 0 1 0-1.414-1.414L2.776 19.81l.926-3.952a2.3 2.3 0 0 1 1.543-1.662l2.693-.846 2.712 2.712zm11.903-15.05L11.414 14 10 12.586 20.293 2.293a1 1 0 0 1 1.413 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-fancy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenFancy;
